@import "../../../../shared/scss";

$link-focus-padding: 2px;

:host {
  display: block;

  phn-nd-signature-heading {
    display: block;
    inline-size: 100%;
    text-align: center;
    margin-block-start: p-px-to-rem(-52px);
    block-size: p-px-to-rem(38px);

    & .model-signature {
      display: block;
      margin-block: auto;
      margin-inline: auto;
    }
  }

  .all-link {
    display: flex;
    inline-size: fit-content;
    margin-inline: auto;
    margin-block: $pds-spacing-static-x-small $pds-spacing-static-medium;

    @include pds-media-query-min("s") {
      margin-block: $pds-spacing-static-medium $pds-spacing-static-medium;
    }
  }

  &:has(phn-model-tile) {
    .skeleton-link {
      margin-block: $pds-spacing-fluid-x-small !important;
      margin-inline: 0 !important;
      block-size: p-px-to-rem(56px) !important;
    }

    .skeleton-image {
      inline-size: 100% !important;
      margin-block: unset !important;
      margin-inline: unset !important;
      block-size: p-px-to-rem(215px) !important;
    }

    .series-body-type {
      @include pds-media-query-min("s") {
        aspect-ratio: 1.59;
      }

      max-inline-size: $max-model-width;
      inline-size: 100%;

      a {
        text-decoration: none;
      }
    }

    .model-link {
      outline-offset: -2px;

      &:focus-visible {
        outline-color: $pds-theme-light-state-focus;
      }
    }

    phn-nd-signature-heading {
      --signature-size: #{p-px-to-rem(38px)};
    }

    .model-signature {
      display: block;
      margin-block: auto;
      margin-inline: auto;
    }

    .sticky-links {
      box-sizing: border-box;
      display: grid;
      margin-inline: auto;
    }

    .non-sticky-link {
      inline-size: 100%;
      max-inline-size: $max-model-width;

      &.first {
        @include pds-media-query-max("s") {
          margin-block-start: 4px;
        }
      }
    }

    .sticky-links {
      gap: $pds-spacing-static-small;
      position: sticky;
      inset-block-end: 0;
      padding-block: 12px $pds-spacing-static-medium;
      inline-size: 100%;
      background-color: $pds-theme-light-background-base;
      @include pds-media-query-min("s") {
        inset-inline-end: calc(5% + var(--scrollbar-width, 0));
        background-color: $pds-theme-light-background-surface;
      }

      & li {
        inline-size: 100%;
        text-align: center;

        & .link {
          inline-size: 100%;
          max-inline-size: $max-model-width;
          margin-inline: auto;
        }
      }
    }

    ul:has(phn-model-tile) {
      display: grid;
      place-items: center;
      gap: $pds-spacing-static-small + $pds-spacing-static-x-small;
      margin-block-end: $pds-spacing-static-large;

      @include pds-media-query-min("s") {
        gap: $pds-spacing-static-medium;
      }

      & li {
        list-style: none;

        &:has(.banner) {
          aspect-ratio: unset;
        }
      }
    }
  }

  ul {
    margin-block: 0;
    margin-inline: 0;
    padding-block: 0;
    padding-inline: 10%;

    @include pds-media-query-max("s") {
      padding-inline: p-px-to-rem(27px);
    }

    & li {
      list-style: none;
    }
  }

  phn-p-headline {
    font-size: p-px-to-rem(28px);
  }

  .model-link-content {
    @include hoverZoom();
    padding-block-end: 5px;
  }

  .skeleton-bodytype {
    block-size: p-px-to-rem(135px);
    inline-size: p-px-to-rem(260px);
    margin-block: 0;
    margin-inline: 0;
    margin-inline-start: p-px-to-rem(24px);
    background: $pds-theme-light-contrast-low;
    border-radius: 4px;

    @include pds-media-query-min("s") {
      block-size: p-px-to-rem(120px);
      inline-size: p-px-to-rem(260px);
    }
  }

  &.skeleton {
    pointer-events: none;
    user-select: none;
    opacity: 60%;

    & .skeleton-headline {
      inline-size: auto;
      block-size: p-px-to-rem(38px);
      background: $pds-theme-light-contrast-low;
      border-radius: 4px;
    }

    & .skeleton-link {
      inline-size: auto;
      block-size: p-px-to-rem(48px);
      margin-block: p-px-to-rem(16px);
      margin-inline: 0;
      background: $pds-theme-light-contrast-low;
      border-radius: 4px;
    }

    & .skeleton-image {
      inline-size: auto;

      max-inline-size: $max-model-width;

      block-size: p-px-to-rem(135px);
      margin-block: p-px-to-rem(24px);
      margin-inline: 0;
      background: $pds-theme-light-contrast-low;
      border-radius: 4px;

      @include pds-media-query-min("s") {
        block-size: p-px-to-rem(120px);
      }

      @include pds-media-query-min("m") {
        block-size: p-px-to-rem(137px);
      }

      @include pds-media-query-min("xxl") {
        block-size: p-px-to-rem(145px);
      }
    }
  }

  .series-body-type {
    text-align: center;
  }

  .car-models {
    phn-p-text {
      font-size: p-px-to-rem(16px);

      @include pds-media-query-min("s") {
        font-size: p-px-to-rem(16px);
      }

      @include pds-media-query-min("xxl") {
        font-size: p-px-to-rem(18px);
      }
    }
  }
}
